import { useMutation } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

export default function useUploadImages() {
  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: FormData) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/common/files/upload-images`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: payload,
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSuccess: (data) => {
      console.log(data);

      window.localStorage.setItem(
        'subjectPropertyImages',
        JSON.stringify(data),
      );
    },
  });
}
